<template>
  <div class="container">
    <ul class="progressbar">
      <li
        v-for="(step, index) in steps"
        :key="step"
        :class="[
          'step-label',
          {
            active: index === currentStep,
            error: index < currentStep && stepErrors[index] && stepErrors[index].length,
            completed: index < currentStep && !(stepErrors[index] && stepErrors[index].length),
          },
        ]"
      >
        <div class="step-circle" @click="$emit('stepClick', index)">{{ index + 1 }} </div>
        <div class="step-title"
          >{{ step }}
          <div v-if="stepErrors[index] && stepErrors[index].length" class="tooltip">
            <div v-for="(err, i) in stepErrors[index]" :key="i"> • {{ err }} </div>
          </div></div
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: function () {
        return ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5'];
      },
    },
    currentStep: { type: Number, default: 0 },
    stepErrors: Object,
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 1;
}

.progressbar {
  display: flex;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.progressbar li {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  flex: 1;
}

.step-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border: 2px solid #bebebe;
  border-radius: 50%;
  background: white;
  color: #bebebe;
  font-weight: bold;
  z-index: 2;
  transition: all 0.2s ease;
  cursor: pointer;
}

.step-title {
  margin-top: 5px;
  font-size: 12px;
  color: #333;
}

.progressbar li::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  background: #979797;
  top: 15px;
  left: 0;
  margin-left: -80px;
  z-index: 1;
}

.progressbar li:first-child::after {
  content: none;
}

.progressbar li.active .step-circle {
  border-color: #4a6cf7;
  background: white;
  color: #4a6cf7;
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.15);
  transform: scale(1.15);
}
.progressbar li.active::after {
  border-color: #4a6cf7;
  background: #4a6cf7;
  color: #4a6cf7;
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.15);
}

.step-label {
  position: relative;
}

.tooltip {
  display: none;
  position: absolute;
  background: #333;
  color: #fff;
  font-size: 11px;
  border-radius: 6px;
  white-space: nowrap;
  text-align: left;
  z-index: 10;
}

.step-label:hover .tooltip {
  display: block;
}

.progressbar li.completed .step-circle {
  border-color: #4caf50;
  background: #4caf50;
  color: white;
}

.progressbar li.completed::after {
  background: #4caf50;
}

.progressbar li.error .step-circle {
  border-color: #ff4d4f !important;
  background: #ff4d4f !important;
  color: white !important;
}

.progressbar li.error::after {
  background: #ff4d4f !important;
}
</style>
